import { render, staticRenderFns } from "./MediaManagement.vue?vue&type=template&id=4d4a4e55&scoped=true&"
import script from "./MediaManagement.vue?vue&type=script&lang=js&"
export * from "./MediaManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d4a4e55",
  null
  
)

export default component.exports